import { useRoutes } from 'react-router-dom';
import { PartialRouteObject } from 'react-router';
import React, { lazy } from 'react';
import LoginPage from '../views/login';
import LayoutPage from '../views/layout'
const Dashboard = lazy(() => import('../views/dashboard'))
const BasicsSettings = lazy(() => import('../views/basicsSettings'))
const EditionManage = lazy(() => import('../views/editionManage'))
const Account = lazy(() => import('../views/account'))
const Role = lazy(() => import('../views/role'))
const ReleaseEdition = lazy(() => import('../views/editionManage/releaseEdition'))

const routerList: PartialRouteObject[] = [
  {
    path: '',
    element: <LayoutPage />,
    children: [
      {
        path: '/',
        element: <BasicsSettings />
      },
      {
        path: '/appbasic',
        element: <BasicsSettings />
      },
      {
        path: '/appversion',
        element: <EditionManage />
      },
      {
        path: '/releaseEdition',
        element: <ReleaseEdition />
      },
      {
        path: '/account',
        element: <Account />
      },
      {
        path: '/role',
        element: <Role />
      }
    ]
  },
  {
    path: '/login',
    element: <LoginPage />
  }
]

export default () => useRoutes(routerList)
